import type { ProcessingModelsResponse } from '../api';

interface ProcessingModelsBadgeProps {
  models?: ProcessingModelsResponse | null | undefined;
}

/**
 * Inline badge pair that surfaces the OCR and LLM model identifiers used to process a document.
 * Returns null when `models` is absent or null (pre-feature documents or CU-only path where
 * neither model id is known). When only one model is known the other badge is hidden entirely
 * (rather than showing a dash) to keep the header uncluttered for legacy documents.
 */
export function ProcessingModelsBadge({ models }: ProcessingModelsBadgeProps): JSX.Element | null {
  if (models === null || models === undefined) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5" aria-label="Modelos de procesamiento">
      {models.ocrModel !== null && models.ocrModel !== undefined && (
        <span className="inline-flex items-center rounded border border-cyan-200 bg-cyan-50 px-2 py-0.5 font-mono text-xs text-cyan-700">
          OCR: {models.ocrModel}
        </span>
      )}
      {models.llmModel !== null && models.llmModel !== undefined && (
        <span className="inline-flex items-center rounded border border-violet-200 bg-violet-50 px-2 py-0.5 font-mono text-xs text-violet-700">
          IA: {models.llmModel}
        </span>
      )}
    </div>
  );
}
